module.exports = __webpack_public_path__ + "static/media/wave-dark.e95bd83d.svg";